<template>
  <div class="s-layout" :style="colorObject">
    <Loading v-if="isLoading" loading-message="載入中..." :background-color="'#ffffff'" />
    <div class="s-container">
      <div class="content">
        <div class="custom-elanco-header">
          <span class="custom-elanco-header__text">Hi {{ deepGet(user, 'name') }}</span>
          <a :href="deepGet(event, 'config.header_logo_url', '#')">
            <img
              v-if="deepGet(event, 'config.images.header_logo')"
              :src="deepGet(event, 'config.images.header_logo')"
              class="custom-elanco-header__image ml-3"
            >
          </a>
        </div>
        <div v-if="!isLoading" class="content__success">
          <template v-if="successfullyApplied">
            <img v-if="event.config.images" :src="event.config.images.redeem_success" alt="Elanco" class="img-fluid">
            <div class="py-3 px-4">
              <div class="text-center py-3 content__success__title">{{ deepGet(event, 'config.expo_2025.applied_success_message', '兌換券領取成功')}}</div>
              <button class="s-btn s-btn-outline-primary s-btn-xs" type="button" @click="goToCouponList">
                {{ deepGet(event, 'config.expo_2025.applied_success_button_text', '查看回饋詳情')}}
              </button>
            </div>
          </template>
          <template v-else>
            <img v-if="event.config.images" :src="event.config.images.redeem_confirm_kv" alt="Elanco" class="img-fluid">
            <div class="py-3 px-4">
              <button class="s-btn s-btn-outline-primary s-btn-xs" type="button" @click="goToCouponList">
                {{ deepGet(event, 'config.member_center_text', '返回會員專區') }}
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Packages
import { mapGetters } from "vuex";
import deepGet from "lodash/get";
// Waltily Utils
import { themeColorFn } from "@/mixins/liff/themeColor";
import dateOptionMixin from "@/mixins/liff/dateOption";
import https from "@/apis/liff/v2/https";
// Components
import Loading from "@/components/Page/Liff/Shared/Loading";

// Api
import redeemApi from "@/apis/liff/v2/redeem";

export default {
  mixins: [
    themeColorFn({ themeConfigPage: 'redeem' }),
    dateOptionMixin,
  ],
  components: {
    Loading,
  },
  mounted() {
    if (this.$route.query.event_code) {
      this.eventCode = this.$route.query.event_code;
    } else {
      this.$swal({
        // title: '提醒',
        text: '網址錯誤，沒有活動代碼',
        confirmButtonText: '確定',
      })
      this.page = 'empty_message';
      return;
    }

    if (this.$route.params.code) {
      this.code = this.$route.params.code;
    } else {
      this.page = 'card';
    }

    this.fetchEvent();
  },
  data() {
    return {
      isLoading: false,
      eventCode: null,
      event: {
        config: {},
      },
      successfullyApplied: false,
    };
  },
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
      themeConfig: "liffGeneral/themeConfig",
    }),
    ...mapGetters("liffAuth", ["user"]),
  },

  methods: {
    deepGet,
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("liff_redeem", key);
    },
    async fetchEvent() {
      try {
        this.isLoading = true;

        const eventRes = await redeemApi.getRedeemEvent({
          event_code: this.eventCode,
        });

        this.event = eventRes.data.data.event;
        this.error_message = eventRes.data.data.event.config.error_message ?? [];

        await https.post(`${this.$store.state.liffGeneral.orgCode}/liff/elanco/expo_2025/apply`, {
          event_code: this.eventCode,
        })
        this.successfullyApplied = true;
      } catch (error) {
        console.warn('Applying failed.', error);
        if (error.response.status === 400) {
          const errorMessageConfig = this.findMappedError(error.response.data.message);
          this.$swal({
            // title: deepGet(errorMessageConfig, 'title', '提醒'),
            text: deepGet(errorMessageConfig, 'message', '設定錯誤'),
            confirmButtonText: '確定',
          })
        } else {
          this.$swal({
            // title: '提醒',
            text: '活動資訊讀取失敗',
            confirmButtonText: '確定',
          })
        }
      } finally {
        this.isLoading = false;
      }
    },
    goToCard() {
      this.$router.push({ name: 'LiffProjElanco', query: { event_code: this.eventCode } });
    },
    goToCouponList() {
      this.$router.push({ name: 'LiffCouponListMy' });
    },
    findMappedError(code) {
      const errorMessageConfig = this.error_message ?? [];
      return errorMessageConfig.find(item => item.code === code);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/liff/main.css";
@import "../../../../assets/css/liff/liff_init_theme_config.css";
@import '../../../../assets/scss/shared/components/_fields.scss';

.custom-elanco-header {
  padding: 16px;
  background-color: #93bf65;
  color: #fff;
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__image {
    height: 40px;
  }
}

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
}

.s-layout,
.s-layout *,
.s-layout *:before,
.s-layout *:after {
  --s-secondary: #de006f;
  --s-warning: #ed6c00;
  --s-danger: #fe0000;
  --s-gray-darker: #363636;
  --s-gray-dark: #2c2c2e;
  --s-gray: #979797 !important;
  --s-gray-light: #c0c4cc;
  --s-gray-lighter: #f2f2f7;
  --liff-button-color: #93bf65;
  --liff-primary_text_color: #93bf65;
  --s-primary: #93bf65;
}

.s-container {
  min-height: 100vh;
  position: relative;
  max-width: 768px;
  margin: auto;
}

.content {
  height: 100vh;
  overflow-y: auto;
  margin: 0;
  padding-bottom: 24px;
  color: var(--liff-primary_text_color);

  &__success {
    &__title {
      font-size: 24px;
      font-weight: 600;
    }
  }
}
</style>
